import React from "react";

import styles from "./GenericEmbed.module.scss";

interface SanityGenericEmbed {
  title: string;
  src: string;
  width?: string;
  height?: string;
  scrolling?: boolean;
}

const GenericEmbed = ({
  node: { title, src, width = "100%", height, scrolling = false }
}: {
  node: SanityGenericEmbed;
}) => {
  return (
    <iframe
      className={styles.root}
      src={src}
      title={title}
      scrolling={scrolling ? "auto" : "no"}
      style={{ width, height }}
    />
  );
};

export default GenericEmbed;
